import axios from "../../plugins/axios-common";

export default {
	actions: {
		getSubmitSmsCode(ctx, pload) {
			return new Promise((resolve, reject) => {
				axios({
					method: 'post',
					url: '/api/cash/order/get-otp',
					data: pload,
				}).then((response) => {
					ctx.commit('updateUserData', response.data)
					resolve(response)
				}).catch((e) => {
					reject(e)
				})
			})
		},
        fetchUserDataAxios(ctx) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/cash/loggedinuser',
                }).then((response) => {
                        ctx.commit('updateUserData', response.data)
                        resolve(response)
                    }).catch((e) => {
                    reject(e)
                })
            })
		},
	},
	mutations: {
		updateUserData(state, user) {
			state.user = user
		}
	},
	state: {
		user: {}
	},
	getters: {
		userData(state) {
			return state.user
		}
	}
}
